import { VoucherApi } from '@/api/voucher'

const state = () => ({
    voucherGenerate: [],
    voucherGeneratePagination: {
        page: 1,
        perPage: 10,
        total: 0,
        code: '',
        uuid: '',
    },
    voucherGenerateDetail: null,
    voucherClassroom: [],
    voucherClassroomQuery: {},
    voucherClassroomPagination: {},
    voucherClassroomDetail: null,
    voucher: null,
    isLoadingVoucher: false,
    isUpdatingVoucher: false,
    updatedDataVoucher: null,
    isSuccessVoucher: true,
    messageVoucher: '',
    voucherGenerateItem: [],
    userVoucher: [],
    voucherUserDetail: {
        perPage: 10,
        first: 0,
    }
})

const getters = {
    voucherGenerateList: state => state.voucherGenerate,
    voucherGeneratePagination: state => state.voucherGeneratePagination,
    voucherGenerateDetail: state => state.voucherGenerateDetail,
    isLoadingVoucher: state => state.isLoadingVoucher,
    isUpdatingVoucher: state => state.isUpdatingVoucher,
    updatedDataVoucher: state => state.updatedDataVoucher,
    isSuccessVoucher: state => state.isSuccessVoucher,
    messageVoucher: state => state.messageVoucher,
    voucherGenerateItem: state => state.voucherGenerateItem,
    voucherClassroomList: state => state.voucherClassroom,
    voucherClassroomPagination: state => state.voucherClassroomPagination,
    voucherClassroomDetail: state => state.voucherClassroomDetail,
    historyVoucher: state => state.userVoucher,
    voucherUserDetail: state => state.voucherUserDetail,
}

const actions = {
    async fetchVoucherClassroom({ commit }, query = null) {
        let page = 1
        let perPage = 10
        let code = ''
        let uuid = ''
        let classroomId = 0
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            code = query.code
            uuid = query.uuid
            classroomId = query.classroomId
        }
        commit('setLoadingVoucher', true)
        await VoucherApi.getVoucherClassrooms(page, perPage, uuid, code, classroomId)
            .then(res => {
                commit('setVoucherClassroom', res.data.data)
                const pagination = {
                    total: res.data.pages.total,
                    perPage: res.data.pages.per_page,
                    page: res.data.pages.current_page,
                    code: code,
                    from: res.data.pages.from,
                    classroomId: classroomId,
                }
                commit('setVoucherClassroomPagination', pagination)
                commit('setLoadingVoucher', false)
            })
            .catch(error => {
                commit('setLoadingVoucher', false)
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error)
            })
    },
    async fetchUserVoucher({ commit }, id) {

        commit('setLoadingVoucher', true)

        await VoucherApi.getUserVoucher(id)
            .then(response => {
                commit('setUserVoucher', response.data.data)
                commit('setLoadingVoucher', false)
            })
            .catch(error => {
                console.log(error)
                commit('setLoadingVoucher', false)
            })
    },
    async fetchVoucherGenerate({ commit }, query = null) {
        let page = 1
        let perPage = 10
        let search = ''
        let classroomCode = ''
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
            classroomCode = query.classroomCode
        }
        commit('setLoadingVoucher', true)
        await VoucherApi.getVoucherGenerate(perPage, page, search, classroomCode)
            .then(response => {
                commit('setVoucherGenerate', response.data.data)
                const pagination = {
                    total: response.data.pages.total,
                    perPage: response.data.pages.per_page,
                    page: response.data.pages.current_page,
                    search: query.search,
                    from: response.data.pages.from,
                    classroomCode,
                }
                commit('setVoucherGeneratePagination', pagination)
                commit('setLoadingVoucher', false)
            })
            .catch(error => {
                console.log(error)
                commit('setLoadingVoucher', false)
            })
    },
    async fetchDetailVoucherGenerate({ commit, getters, dispatch }, id) {
        commit('setLoadingVoucher', true)
        await VoucherApi.detailVoucherGenerate(id)
            .then(async response => {
                if (response.data.data) {
                    commit('setSuccessVoucher', true)

                    commit('setVoucherGenerateDetail', response.data.data)
                    if (response.data.data.items) {
                        let classrooms = getters['allClassrooms']
                        if (classrooms.length == 0) {
                            await dispatch('fetchListClassrooms')
                            classrooms = getters['allClassrooms']
                        }

                        const classes = response.data.data.items.split(', ')
                        const selectedClasses = classrooms.filter(function(item) {
                            return classes.indexOf(item.code) !== -1
                        })
                        commit('setVoucherGenerateItem', selectedClasses)
                        commit('setLoadingVoucher', false)
                    }
                } else {
                    commit('setSuccessVoucher', false)
                    commit('setMessageVoucher', 'Voucher Tidak Ditemukan')
                }
            })
            .catch(error => {
                console.log(error)
                commit('setLoadingVoucher', false)
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error)
            })
    },
    async addVoucherGenerate({ commit }, payload) {
        commit('setVoucherIsUpdating', true)
        await VoucherApi.addVoucherGenerate(payload)
            .then(response => {
                console.log(response)
                commit('setSuccessVoucher', true)
                commit('setMessageVoucher', 'Berhasil Generate Voucher')
            })
            .catch(error => {
                console.log(error)
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error)
            })
    },

    async updateVoucherGenerate({ commit }, voucher) {
        // console.log(voucher)
        const id = voucher.id
        const payload = voucher.payload
        commit('setVoucherIsUpdating', true)
        await VoucherApi.updateVoucherGenerate(id, payload)
            .then(response => {
                console.log(response)

                commit('setSuccessVoucher', true)
                commit('setMessageVoucher', 'Update Berhasil')
            })
            .catch(error => {
                console.log(error)
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error)
            })
    },
    async deleteVoucherGenerate({ commit }, id) {
        await VoucherApi.deleteVoucherGenerate(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessVoucher', true)
                    commit('setMessageVoucher', 'Berhasil Menghapus Generate Voucher')
                } else {
                    commit('setSuccessVoucher', false)
                    commit('setMessageVoucher', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error.errors[0].message)
            })
    },
    async detailVoucherClassroom({ commit }, id) {
        commit('setLoadingVoucher', true)
        await VoucherApi.detailVoucherClassroom(id)
            .then(res => {
                commit('setVoucherClassroomDetail', res.data.data)
                commit('setSuccessVoucher', true)
                commit('setLoadingVoucher', false)
            })
            .catch(error => {
                commit('setLoadingVoucher', false)
                commit('setSuccessVoucher', false)
                commit('setMessageVoucher', error.errors[0].message)
            })
    },
    saveVoucherUserDetail({ commit }, pages) {
        commit('setVoucherUserDetail', pages)
    },
}

const mutations = {
    setVoucherClassroom: (state, voucherClassroom) => {
        state.voucherClassroom = voucherClassroom
    },
    setUserVoucher: (state, userVoucher) => {
        state.userVoucher = userVoucher
    },
    setVoucherClassroomPagination: (state, pagination) => {
        state.voucherClassroomPagination = pagination
    },
    setVoucherClassroomDetail: (state, detail) => {
        state.voucherClassroomDetail = detail
    },
    setVoucherGenerate: (state, voucherGenerate) => {
        state.voucherGenerate = voucherGenerate
    },

    setVoucherGeneratePagination: (state, voucherGeneratePagination) => {
        state.voucherGeneratePagination = voucherGeneratePagination
    },

    setVoucherGenerateDetail: (state, voucherGenerateDetail) => {
        state.voucherGenerateDetail = voucherGenerateDetail
    },

    setLoadingVoucher: (state, isLoading) => {
        state.isLoadingVoucher = isLoading
    },

    setVoucherIsUpdating: (state, isUpdating) => {
        state.isUpdatingVoucher = isUpdating
    },

    setSuccessVoucher: (state, isSuccess) => {
        state.isSuccessVoucher = isSuccess
    },

    setMessageVoucher: (state, message) => {
        state.messageVoucher = message
    },

    setVoucherGenerateItem: (state, item) => {
        state.voucherGenerateItem = item
    },

    setVoucherUserDetail: (state, pages) => {
        state.voucherUserDetail = pages
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}